import Chip, { ChipProps } from "@mui/material/Chip";
import { PalletStatus } from "../../types/pallet-summary.type";

const STATUS_LABEL: Record<PalletStatus, string> = {
  MATCHED: "ตรงกัน",
  MISMATCHED: "มีส่วนต่าง",
  NEEDS_REVIEW: "ควรตรวจสอบ",
};

/** A count that is not in yet outranks a count that disagrees: the figures cannot be trusted. */
const STATUS_COLOR: Record<PalletStatus, ChipProps["color"]> = {
  MATCHED: "success",
  MISMATCHED: "warning",
  NEEDS_REVIEW: "error",
};

/** The server decides the status of a trip, route or branch; this only names and colours it. */
export default function PalletStatusChip({
  status,
}: Readonly<{ status: PalletStatus }>) {
  return (
    <Chip size="small" label={STATUS_LABEL[status]} color={STATUS_COLOR[status]} />
  );
}
